function n(u, e, t) {
  for (var r = 0, d = t.length; r < d; ) {
    if (e = u["@@transducer/step"](e, t[r]), e && e["@@transducer/reduced"]) {
      e = e["@@transducer/value"];
      break;
    }
    r += 1;
  }
  return u["@@transducer/result"](e);
}
export {
  n as default
};
